import { useParams } from "react-router";
import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, CardMedia, Typography } from "@mui/material";
import VetMap from "./VetMap";
import { ICoordinates } from "../../types/vet.types";
import vetService from "@fuse/services/vetService";

function VetProfile({ vet }) {
	const params = useParams();
	const siteId = params.id;
	const [coords, setCoords] = useState<ICoordinates>({} as ICoordinates);
	const [site, setSite] = useState<any>(null);

	useEffect(() => {
		loadSiteDetail();
	}, []);

	async function convertGooglePhotoUrl(logoUrl: string) {
		if (!logoUrl) return null;

		// match the photo reference that comes right after `?1s`
		const match = logoUrl.match(/[?&]1s([^&]+)/);
		console.log("match", match)
		if (match && match[1]) {
			const photoReference = match[1];
			return `https://maps.googleapis.com/maps/api/place/photo?maxheight=300&maxwidth=400&photo_reference=${photoReference}&key=${process.env.VITE_APP_GOOGLE}`;
		}

		return logoUrl;
	}

	async function loadSiteDetail() {
		const res = (await vetService.getSiteById(siteId)) as any;
		if (res) {
			setSite(res.result);
			if (res.result.placesJson) {
				const placeDetails = JSON.parse(res.result.placesJson);
				//const url = placeDetails.photos[0].getUrl({ maxHeight: 300 });

				vet.address1 = placeDetails.formatted_address;
				setCoords({
					latitude: placeDetails.geometry.location.lat(),
					longitude: placeDetails.geometry.location.lng(),
				});
				vet.phoneNumber = placeDetails.formatted_phone_number;
				vet.rating = +placeDetails.rating;
				const fixedLogo = await convertGooglePhotoUrl(res.result.logo);
				vet.imageUrl = fixedLogo || "assets/img/logo.png";

				if (
					placeDetails.types &&
					placeDetails.types.includes("veterinary_care")
				)
					vet.practiceType = "Veterinary Care";
			}
		}
	}

	return (
		<React.Fragment>
			<>
				<div className="flex w-full flex-col sm:flex-row gap-11">
					<div className="flex w-full md:w-3/5 h-208">
						{vet.id && (
							<Card key={vet.id} className="flex w-full my-5 flex-col">
								<div className="flex w-full">
									<CardMedia
										className="w-112 p-10 rounded-20"
										component="img"
										image={vet.imageUrl || "assets/img/logo.png"}
										alt={vet.name}
									/>
									<Box sx={{ display: "flex", flexDirection: "column" }}>
										<CardContent sx={{ flex: "1 0 auto" }}>
											<Typography component="div" variant="h5">
												{vet.name}
											</Typography>
											<Typography
												variant="subtitle1"
												color="text.secondary"
												component="div"
											>
												{vet.practiceType}
											</Typography>
										</CardContent>
									</Box>
								</div>
								<div className="flex w-full flex-col px-24">
									<Typography className="flex w-full">
										{vet.phoneNumber}
									</Typography>
									<Typography className="flex w-full">
										{vet.address1}
									</Typography>
								</div>
							</Card>
						)}
					</div>

					<div className="flex w-full md:w-2/5">
						{coords.latitude && coords.longitude && (
							<VetMap lat={coords.latitude} lng={coords.longitude} />
						)}
					</div>
				</div>
			</>
		</React.Fragment>
	);
}

export default VetProfile;
